<template>
  <div class="centered-container">
    <v-card class="elevation-3" width="400px">

      <div class="my-title">
        <img class="logo" src="../assets/logo.png" alt="logo">
        <div class="title">Admin Portal</div>
        <div class="body-1">Internal only</div>
      </div>

      <v-btn block class="sign-in-google-button white--text" color="primary" @click="signInWithGoogle" height="45" max-width="330">
        <img class="google-icon" src="../assets/google-sign-in.svg" alt="logo">
        <span class="google-text">Google Sign In</span>
      </v-btn>

      <v-overlay :value="loading">
        <v-progress-circular :size="50" color="primary" indeterminate v-if="loading"/>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      loading: false
    }
  },
  methods: {
    signInWithGoogle () {
      this.loading = true
      this.$store.dispatch('signInWithGoogle')
        .then(authenticated => {
          this.loading = false
          if (!authenticated) {
            alert('This account does not have access to the Admin Portal')
          }
        })
        .catch(error => {
          console.error("Error:'" + error.code + "'occurred with message: " + error.message)
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss">

.centered-container {
  background: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;

  .v-card {
    padding-left: 20px;
    padding-right: 20px;
  }

  .my-title {
    padding-top: 85px;
    text-align: center;
    .logo {
      width: 280px;
      height: 69px;
      margin-left: -10px;
      margin-bottom: 70px;
    }
  }

  .sign-in-google-button {
    margin-bottom: 45px;
    margin-top: 35px;
    .google-icon {
      height: 46px;
      width: 46px;
    }
    .google-text {
      margin-left: 12px;
      margin-right: 15px;
    }
  }
}
</style>
